var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenHighlightMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.327778 2.61276L3.05 5.30803C3.57222 5.82508 4.27778 6.11111 5.01667 6.11111L14.9889 6.11111C15.7278 6.11111 16.4333 5.81958 16.9556 5.30803L19.6722 2.61276C19.8833 2.40374 20 2.12871 20 1.83718V0H0V1.83168C0 2.12321 0.116667 2.40374 0.327778 2.60726V2.61276ZM6.25 21.179V13.0426C6.25 12.5896 6.6231 12.2224 7.08333 12.2224H12.9167C13.3769 12.2224 13.75 12.5896 13.75 13.0426V18.4996C13.75 18.8183 13.5625 19.1081 13.2691 19.2429L7.43574 21.9222C6.88325 22.176 6.25 21.779 6.25 21.179ZM15.2083 7.33333L4.79167 7.33333C4.21637 7.33333 3.75 7.88054 3.75 8.55556L3.75 9.77778C3.75 10.4528 4.21637 11 4.79167 11L15.2083 11C15.7836 11 16.25 10.4528 16.25 9.77778V8.55556C16.25 7.88054 15.7836 7.33333 15.2083 7.33333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenHighlightMedium);
export default __webpack_public_path__ + "static/media/pen-highlight-medium.40cb6e0bcf1e4ae55dd8b2bbc8449eee.svg";
export { ForwardRef as ReactComponent };